import {getBudgetConcepts, getBudgetPrefixes, getBudgetTitles, getBudgetCompanyCategories, getBudgetCompanyDetails, getCompanyBudgetNoteTemplates, getCompanyBudgets} from '@/helpers/api/budgets'
const listingColumns = localStorage.getItem('serials_columns')

const messagesStore = {
  namespaced: true,
  state: {
		listingColumns: listingColumns ? JSON.parse(listingColumns):{
			client: true,
			project: true,
			reports: true,
			vt_report: true,
			pp_report: true,
			pr_report: true,
			budgets: true,
			vt_budget: true,
			pp_budget: true,
			contracts: true,
			variable: []
		},
		budgetComponentModalId: null,
		scrolledBudget: 0,
		budgetHeaderHeight: 0,
		budgetSecondHeaderHeight: 0,
		loadingBudgetPrefixes: false,
		companiesBudgetPrefixes: [],
		companiesBudgetPrefixesCount: 0,
		newBudgetPrefixModal: false,
		newBudgetPrefixModalEditing: null,
		newBudgetTitleModal: false,
		newBudgetTitleModalEditing: null,
		loadingBudgetTitles: false,
		companiesBudgetTitles: [],
		loadingBudgetConcepts: false,
		companiesBudgetConcepts: [],
		newBudgetConceptModal: false,
		newBudgetConceptModalEditing: null,
		loadingBudgetCategories: false,
		companiesBudgetCategories: [],
		newBudgetCategoryModal: false,
		newBudgetCategoryModalEditing: null,
		loadingBudgetDetails: false,
		companiesBudgetDetails: [],
		loadingBudgetNotes: false,
		companiesBudgetNotes: [],
		newBudgetDetailModal: false,
		newBudgetDetailModalEditing: null,
		newBudgetNoteTemplateModal: false,
		newBudgetNoteTemplateModalEditing: null,
		loadingCompanyBudgets: true,
		companyBudgets: [],
		companyBudgetsCount: 0,
		modalNewBudget: false,
		modalNewBudgetInfo: null,
		budgetPdfModal: null,
		budgetEditorRef: null,
		budgetModalId: false
  },
  mutations: {
    setListingColumns(state, listingColumns) {
      state.listingColumns = listingColumns
			localStorage.setItem('serials_columns', JSON.stringify(listingColumns))
    },
		setScrolledBudget(state, value) {
			state.scrolledBudget = value
		},
		setBudgetHeaderHeight(state, value) {
			state.budgetHeaderHeight = value
		},
		setBudgetSecondHeaderHeight(state, value) {
			state.budgetSecondHeaderHeight = value
		},
		setNewBudgetPrefixModal(state, value){
			state.newBudgetPrefixModal = value
		},
		setNewBudgetPrefixModalEditing(state, value){
			state.newBudgetPrefixModalEditing = value
		},
		setLoadingBudgetPrefixes(state, value){
			state.loadingBudgetPrefixes = value
		},
		setCompaniesBudgetPrefixes(state, value){
			state.companiesBudgetPrefixes = value
		},
		setCompaniesBudgetPrefixesCount(state, value){
			state.companiesBudgetPrefixesCount = value
		},
		setNewBudgetTitleModal(state, value){
			state.newBudgetTitleModal = value
		},
		setNewBudgetTitleModalEditing(state, value){
			state.newBudgetTitleModalEditing = value
		},
		setLoadingBudgetTitles(state, value){
			state.loadingBudgetTitles = value
		},
		setCompaniesBudgetTitles(state, value){
			state.companiesBudgetTitles = value
		},
		setNewBudgetConceptModal(state, value){
			state.newBudgetConceptModal = value
		},
		setNewBudgetConceptModalEditing(state, value){
			state.newBudgetConceptModalEditing = value
		},
		setLoadingBudgetConcepts(state, value){
			state.loadingBudgetConcepts = value
		},
		setCompaniesBudgetConcepts(state, value){
			state.companiesBudgetConcepts = value
		},
		setNewBudgetCategoryModal(state, value){
			state.newBudgetCategoryModal = value
		},
		setNewBudgetCategoryModalEditing(state, value){
			state.newBudgetCategoryModalEditing = value
		},
		setLoadingBudgetCategories(state, value){
			state.loadingBudgetCategories = value
		},
		setCompaniesBudgetCategories(state, value){
			state.companiesBudgetCategories = value
		},
		setNewBudgetDetailModal(state, value){
			state.newBudgetDetailModal = value
		},
		setNewBudgetDetailModalEditing(state, value){
			state.newBudgetDetailModalEditing = value
		},
		setLoadingBudgetDetails(state, value){
			state.loadingBudgetDetails = value
		},
		setCompaniesBudgetDetails(state, value){
			state.companiesBudgetDetails = value
		},
		setNewBudgetNoteTemplateModal(state, value){
			state.newBudgetNoteTemplateModal = value
		},
		setNewBudgetNoteTemplateModalEditing(state, value){
			state.newBudgetNoteTemplateModalEditing = value
		},
		setLoadingBudgetNotes(state, value){
			state.loadingBudgetNotes = value
		},
		setCompaniesBudgetNotes(state, value){
			state.companiesBudgetNotes = value
		},
		setLoadingCompanyBudgets(state, value){
			state.loadingCompanyBudgets = value
		},
		setCompanyBudgets(state, value){
			state.companyBudgets = value
		},
		setCompanyBudgetsCount(state, value){
			state.companyBudgetsCount = value
		},
		setModalNewBudget(state, value){
			state.modalNewBudget = value
		},
		setModalNewBudgetInfo(state, value){
			state.modalNewBudgetInfo = value
		},
		setBudgetPdfModal(state, pdf) {
			state.budgetPdfModal = pdf
		},
		setBudgetEditorRef(state, value){
			state.budgetEditorRef = value
		},
		setBudgetModalId(state, value){
			state.budgetModalId = value
		},
		setBudgetComponentModalId(state, value){
			state.budgetComponentModalId = value
		},
  },
  actions: {
    async getBudgetPrefixes({ commit }, {search = null, start = 0, limit = 300, deleted = false} = {}) {
      commit('setLoadingBudgetPrefixes', true)
      const data = {
        start,
        limit,
				search,
				deleted
      }
      const concepts = await getBudgetPrefixes(data)
      if (concepts.code === 200) {
        commit('setCompaniesBudgetPrefixes', concepts.budget_prefixes)
        commit('setCompaniesBudgetPrefixesCount', concepts.budget_prefixes_count)
      }
      commit('setLoadingBudgetPrefixes', false)
    },
    async getBudgetTitles({ commit }) {
      commit('setLoadingBudgetTitles', true)
      const data = {
        start: 0,
        limit: 300
      }
      const titles = await getBudgetTitles(data)
      if (titles.code === 200) {
        commit('setCompaniesBudgetTitles', titles.company_budget_titles)
      }
      commit('setLoadingBudgetTitles', false)
    },
    async getBudgetConcepts({ commit }) {
      commit('setLoadingBudgetConcepts', true)
      const data = {
        start: 0,
        limit: 300
      }
      const concepts = await getBudgetConcepts(data)
      if (concepts.code === 200) {
        commit('setCompaniesBudgetConcepts', concepts.budget_concepts)
      }
      commit('setLoadingBudgetConcepts', false)
    },
    async getBudgetCategories({ commit }) {
      commit('setLoadingBudgetCategories', true)
      const data = {
        start: 0,
        limit: 300
      }
      const categories = await getBudgetCompanyCategories(data)
      if (categories.code === 200) {
        commit('setCompaniesBudgetCategories', categories.budget_categories)
      }
      commit('setLoadingBudgetCategories', false)
    },
    async getBudgetDetails({ commit }) {
      commit('setLoadingBudgetDetails', true)
      const data = {
        start: 0,
        limit: 300
      }
      const details = await getBudgetCompanyDetails(data)
      if (details.code === 200) {
        commit('setCompaniesBudgetDetails', details.budget_details)
      }
      commit('setLoadingBudgetDetails', false)
    },
    async getBudgetNotes({ commit }) {
      commit('setLoadingBudgetNotes', true)
      const data = {
        start: 0,
        limit: 300
      }
      const notes = await getCompanyBudgetNoteTemplates(data)
      if (notes.code === 200) {
        commit('setCompaniesBudgetNotes', notes.notes)
      }
      commit('setLoadingBudgetNotes', false)
    },
    async getCompanyBudgets({ commit }, {search = null, start = 0, limit = 20, order_by = 1} = {}) {
      commit('setLoadingCompanyBudgets', true)
      const data = {
				search,
        start,
        limit,
				order_by
      }
      const budgets = await getCompanyBudgets(data)
      if (budgets.code === 200) {
        commit('setCompanyBudgets', budgets.budgets)
				commit('setCompanyBudgetsCount', budgets.budgets_count)
      }
      commit('setLoadingCompanyBudgets', false)
    },
  }
}

export default messagesStore
